import { useModals } from '@frontend/modal';

import { useAppDispatch } from '../../redux/store';

interface ViewProps {
    dispatch: ReturnType<typeof useAppDispatch>;
    openModal: ReturnType<typeof useModals>['openModal'];
    REQUIREMENT_MODAL_ID: string;
}

export const useRequirements = (): ViewProps => {
    const dispatch = useAppDispatch();
    const { openModal } = useModals();
    const REQUIREMENT_MODAL_ID = 'requirement-modal';

    return {
        dispatch,
        openModal,
        REQUIREMENT_MODAL_ID
    };
};
